import PropTypes from "prop-types";
import { mySrcmConfig, l } from "./common-utils";

const profileApiCachedUrl = (api, param1 = "", param2 = "") => {
  let path = "";
  switch (api) {
    case "cities-id":
      path = `/cities/id/${param1}.json`;
      break;
    case "cities-country-prefix":
      path = `/cities/${l(param1)}/${l(param2)}.json`;
      break;
    case "cities-prefix":
      path = `/cities/${l(param1)}.json`;
      break;
    case "states-id":
      path = `/states/id/${param1}.json`;
      break;
    case "states-country-prefix":
      path = `/states/${l(param1)}/${l(param2)}.json`;
      break;
    case "states-prefix":
      path = `/states/${l(param1)}.json`;
      break;
    case "substates-id":
      path = `/substates/id/${param1}.json`;
      break;
    case "substates-country-prefix":
      path = `/substates/${l(param1)}/${l(param2)}.json`;
      break;
    case "substates-prefix":
      path = `/substates/${l(param1)}.json`;
      break;
    case "countries-id":
      path = `/countries/id/${param1}.json`;
      break;
    case "countries-all":
      path = `/countries/all.json`;
      break;
    case "groups-id":
      path = `/groups/id/${param1}.json`;
      break;
    case "groups-parent-id":
      path = `/groups/parent/${param1}.json`;
      break;
    case "groups-center-prefix":
      path = `/center/${l(param1)}.json`;
      break;
    default:
      break;
  }

  return `${mySrcmConfig.staticDataServer}${path}`;
};

profileApiCachedUrl.propTypes = {
  api: PropTypes.oneOf([
    "states-id",
    "states-country-prefix",
    "states-prefix",
    "substates-id",
    "substates-country-prefix",
    "substates-prefix",
    "cities-id",
    "cities-country-prefix",
    "cities-prefix",
    "countries-all",
    "countries-id",
    "groups-id",
    "groups-parent-id",
    "groups-center-prefix",
  ]).isRequired,
  param1: PropTypes.string,
  param2: PropTypes.string,
};

export default profileApiCachedUrl;
